export default __webpack_public_path__ + "static/media/pic3.b8150a36.png";